import { connect } from 'react-redux';
import {
  selectCurrentTariffID,
  selectTariffs,
} from 'src/store/payment/selectors';
import { setCurrentTariff } from 'src/store/payment/slice';
import { getIsHotelOnly } from 'src/store/view/selectors';
import TbankCreditExpanded from './TbankCreditExpanded';

const mapStateToProps = (state) => ({
  tariffs: selectTariffs(state),
  selectedTariffId: selectCurrentTariffID(state),
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = {
  setCurrentTariff,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TbankCreditExpanded);
